import useCustomerId from '../useCustomerId';
import useUser from '../useUser';

/**
 * Returns a boolean indicating if the user has access to area administration features over a client,
 * or if it's restricted to manage specific areas.
 */
const useIsAreasAdmin = () => {
  const { user } = useUser();
  const { customerId } = useCustomerId();

  const isOperationsRole = Boolean(user?.isInternal);
  const hasAreasArray = Array.isArray(user?.metadata?.area?.[customerId]?.values);
  const isClientAdmin = !hasAreasArray || user?.metadata?.area?.[customerId]?.values.length === 0;

  return { isAreasAdmin: isOperationsRole || isClientAdmin };
};

/**
 * Return useIsareasAdmin as a boolean, for easier use in components that only need to know if the user is an areas admin or not.
 * @returns
 */
export const useIsAreasAdminBoolean = () => {
  const { isAreasAdmin } = useIsAreasAdmin();
  return isAreasAdmin;
};

export default useIsAreasAdmin;
